export default "__VITE_ASSET__dca10037__"